import React from 'react';
const FolderFileIcon = _ref => {
  let {
    isFile,
    contentType
  } = _ref;
  if (isFile) {
    return /*#__PURE__*/React.createElement("span", {
      style: {
        color: '#0078B9'
      },
      className: "material-icons"
    }, contentType === 'application/pdf' ? 'picture_as_pdf' : 'description');
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "folder");
  }
};
export default FolderFileIcon;